import { render, staticRenderFns } from "./Credit_Summary_Customer.vue?vue&type=template&id=543df2a2&scoped=true&"
import script from "./Credit_Summary_Customer.vue?vue&type=script&lang=js&"
export * from "./Credit_Summary_Customer.vue?vue&type=script&lang=js&"
import style0 from "./Credit_Summary_Customer.vue?vue&type=style&index=0&id=543df2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543df2a2",
  null
  
)

export default component.exports